<template>
  <div class="common_header">
    <div class="user_center">
      <div v-show="!getUserInfo.isLogin">
        <span @click="loginFun()">登录</span>
        <span class="user_line">|</span>
        <span @click="loginFun()">注册</span>
      </div>
      <div v-show="getUserInfo.isLogin">
        <span>{{getUserInfo.username}}</span>
        <span class="user_line">|</span>
        <span class="award_btn" @click="awardBtnFun()" v-if="getUserInfo.have_award == 1">获奖信息</span>
        <span class="user_line" v-if="getUserInfo.have_award == 1">|</span>
        <span @click="loginOut()">退出 Logout</span>
      </div>
    </div>
    <div class="header">
      <img src="../../img/m_banner.png" alt="" class="banner">
    </div>
    <div class="tab">
      <div class="container">
        <router-link to="/mpage/m_home">
            <div class="cn_name">首页</div>
            <div class="en_name">HOME</div>
        </router-link>
        <router-link to="/mpage/m_notice">
            <div class="cn_name">比赛规则</div>
            <div class="en_name">RULES</div>
        </router-link>
        <a href="javascript:;" :class="[$route.path.includes('m_submit') ? 'router-link-active' : '']" @click="toSubmit()">
            <div class="cn_name">作品提交</div>
            <div class="en_name">SUBMIT</div>
        </a>
        <router-link to="/mpage/m_gallery">
            <div class="cn_name">作品展示</div>
            <div class="en_name">GALLERY</div>
        </router-link>
        <router-link to="/mpage/m_skill/m_skilllist">
            <div class="cn_name">摄影技巧</div>
            <div class="en_name">TECHNIQUES</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  data () {
    return {
      isLogin: false,
      username: ''
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  mounted () {
    this.checkLogin()
  },
  methods: {
    ...mapActions(['setUserInfoAction']),
    // 检查登录状态
    checkLogin () {
      this.$utils.get('/user/checkLogin', { withinfo: 1 }) .then(res => {
        if (res.code === 1000) {
          this.setUserInfoAction({
              isLogin: true,
              username: res.data.username,
              volunteer_info: res.data.volunteer_info,
              have_award: res.data.have_award,
              express: res.data.express
          })
        } else {
          this.setUserInfoAction({
              isLogin: false,
              username: '',
              volunteer_info: 0,
              have_award: 0,
              express: 0
          })
          // this.loginFun()
        }
      })
    },
    // 退出登录
    loginOut () {
      this.$utils.get('/user/logout', { }).then(res => {
        if (res) {
          this.$router.push({
            path: '/mpage/m_home'
          })
        }
      })
    },
    // 登录
    loginFun () {
      const currentUrl = window.location.href
      window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + encodeURIComponent(currentUrl)
    },
    toSubmit () {
      if (!this.getUserInfo.isLogin) {
        this.$dialog.confirm({
          message: '未登录，是否要前往登录',
        })
        .then(() => {
          this.loginFun()
        })
        .catch(() => {
          // on cancel
        })
      } else {
        this.$router.push({
          path: '/mpage/m_submit'
        })
      }
    },
    awardBtnFun () {
      this.$router.push({
        path: '/mpage/m_certificateDetail'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.common_header {
    width: 100%;
    min-height: 100%;
    position: relative;
    font-family: 'Microsoft YaHei';
    font-size: 0;
    background-image: url(../../img/bg.png);
    background-size: 100%;
    background-repeat: repeat;
    .user_center {
      background: #fff;
      height: 1.5rem;
      line-height: 1.5rem;
      padding-right: .75rem;
      text-align: right;
      color: #000;
      font-size: .5rem;
      .user_line {
        padding: 0 .75rem;
      }
      .award_btn {
        color: #fb3737;
      }
    }
    .header {
        width: 100%;
        position: relative;
        .banner {
            width: 100%;
        }
        .logo {
            position: absolute;
            bottom: 4%;
            left: 0;
            right: 0;
            margin: auto;
        }
    }
    .tab {
        width: 100%;
        height: 1.6rem;
        background-color: rgba(#fff, 0.7);
        background-image: url(../../img/tab_bg.png);
        background-repeat: no-repeat;
        
        .container {
            width: 100%;
            height: 100%;
            margin: auto;
            overflow: hidden;
            a {
                vertical-align: top;
                display: inline-block;
                text-align: center;
                width: 20%;
                height: 1.6rem;
                // line-height: 1.21rem;
                font-size: 0.55rem;
                color: #0b2ab0;
            }
            .cn_name {
                margin-bottom: .1rem;
                margin-top: .2rem;
            }
            .en_name {
                font-size: 0.33rem;
            }
            .router-link-active {
                background-color: #9576ef;
                color: #fff;
            }
        }
    }
    .copyRight {
        // position: absolute;
        bottom: 0px;
        left: 0;
        text-align: center;
        font-size: 20px;
        color: #a38fe9;
        margin-top: 30px;
        padding-bottom: 32px;
        right: 0;
        margin: 30px auto 0;
    }
}
</style>
